import { render } from "./HeaderlessMobile.vue?vue&type=template&id=a4895634&scoped=true"
import script from "./HeaderlessMobile.vue?vue&type=script&lang=js"
export * from "./HeaderlessMobile.vue?vue&type=script&lang=js"

import "./HeaderlessMobile.vue?vue&type=style&index=0&id=a4895634&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4895634"]])

export default __exports__